import Modal from "react-responsive-modal";
import styles from "./styles.module.css";
import close from "../../assets/close.svg";
import "react-responsive-modal/styles.css";
import { ReactNode } from "react";

type Props = {
  show: boolean;
  title: string;
  setShow?: (value: React.SetStateAction<boolean>) => void;
  setShowNumber?: (value: React.SetStateAction<number>) => void;
  children: ReactNode;
  logo?: ReactNode;
  /**
   * Largura máxima do modal, ex.: "760px".
   *
   * O padrão do .customModal é `width: 100%; max-width: none`, ou seja, o
   * modal ocupa a tela toda independente do conteúdo — um formulário estreito
   * fica encostado à esquerda com um vazio enorme à direita. Quem tem conteúdo
   * estreito passa a própria largura aqui.
   */
  maxWidth?: string;
};

const CustomModal = ({
  show,
  title,
  setShow,
  setShowNumber,
  children,
  logo,
  maxWidth,
}: Props) => {
  return (
    <Modal
      open={show}
      onClose={() => {
        if (setShow) setShow(false);
        if (setShowNumber) setShowNumber(-1);
      }}
      center
      classNames={{
        modal: styles.customModal,
      }}
      styles={maxWidth ? { modal: { maxWidth } } : undefined}
      closeIcon={<img className={styles.close} src={close} alt="fechar" />}
    >
      <div className={styles.container}>
        {logo ? (
          <div
            className={`${styles.logo} [&>svg]:w-7 [&>svg]:h-7 bg-brand-sidebar`}
          >
            {logo}
          </div>
        ) : (
          ""
        )}
        <div className={`${styles.titleBox} bg-brand-sidebar`}>
          <h2 className={styles.title}>{title}</h2>
        </div>
        <div className={`${styles.content} text-brand-text`}>{children}</div>
      </div>
    </Modal>
  );
};
export default CustomModal;
